import {GameAssets} from "../GameAssets";

export class SymbolMultiplier extends PIXI.Container {
    private _prefix: string = "x";
    private _multText: PIXI.BitmapText;
    private _fontStyle: any = {
        fontName: GameAssets.GAME_MULTIPLIER,
        fontSize: 6
    };

    constructor(value: number) {
        super();
        this.multValue = value;
        this.init();
    }

    private _multValue: number;

    get multValue(): number {
        return this._multValue;
    }

    set multValue(value: number) {
        this._multValue = value;
    }

    public updateValue(value?: number, isNudgingOverSymbol: boolean = false): void {
        const prevValue: number = parseInt(this._multText.text.split(this._prefix)[1]);
        if (value && value < prevValue && !(isNudgingOverSymbol)) {
            return;
        }
        if (isNudgingOverSymbol) {
            let currMultValue: number = parseInt(this._multText.text.replace(this._prefix, ""));
            this._multText.text = this._prefix + (currMultValue + value!);
        } else if (value) {
            this._multText.text = this._prefix + value;
        } else {
            let currMultValue: number = parseInt(this._multText.text.replace(this._prefix, ""));
            this._multText.text = this._prefix + (++currMultValue);
        }
    }

    private init(): void {
        this._multText = new PIXI.BitmapText(this._prefix + this.multValue, this._fontStyle);
        this._multText.anchor = new PIXI.Point(0.5, 0.5);
        this._multText.position.set(-12, 10);

        this.addChild(this._multText);
        this.alpha = 0;
    }
}